'use strict';

angular.module('atex.aceui.service').factory('ContentStateService',
  ['ContentService',

    function (ContentService) {

      return {
        /**
         * Wraps atex.aceui.service.ContentStateService.updateHiddenState with an authentication
         * guard (provided by AuthenticationService.callWithAuthentication).
         *
         * See documentation for atex.aceui.service.ContentStateService.updateHiddenState.
         * See documentation for AuthenticationService.callWithAuthentication.
         */
        updateHiddenState: function ({ alias, hidden }) {
          return ContentService.getContent({ alias })
            .then((result) => {
              let content = {};
              content.operations = [{
                '_type': 'aceContentMetadata',
                'aspects': {
                  'aceContentState': {
                    '_type': 'aceContentState',
                    'hidden': hidden
                  }
                }
              }];
              return ContentService.updateContent({ alias, content, revision: result.revision });
            });
        },
        /**
         * Utility function to get the hidden state of a content.
         *
         * @param {*} alias
         */
        getHiddenState: function (alias) {
          return ContentService.getContentMetadata({ alias }).then((result) => {
            return atex.aceui.ObjectUtils.getByPath (result, 'metadata/aspects/aceContentState/hidden');
          });
        }
      };
    }
  ]);
